import { createDeferredLoadable } from '../../utils/createDeferredLoadable';
export const LoadablePublicProductFeatureTable = createDeferredLoadable(() => import( /* webpackChunkName: "public-feature-table" */'./PublicFeatureTableSection').then(m => ({
  default: m.PublicFeatureTableSection
})));